import * as React from 'react'
import { SVGProps } from 'react'

const SvgEmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M12 .361a12.013 12.013 0 0 0-12 12c-.126 9.573 11.16 15.43 18.9 9.817a1 1 0 1 0-1.152-1.634C11.3 25.217 1.9 20.34 2 12.361c.55-13.266 19.453-13.263 20 0v2a2 2 0 1 1-4 0v-2c-.252-7.929-11.749-7.928-12 0a6.017 6.017 0 0 0 10.52 3.933A3.999 3.999 0 0 0 24 14.361v-2a12.014 12.014 0 0 0-12-12Zm0 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z'
      fill='#fff'
    />
  </svg>
)

export default SvgEmailIcon
